import {EmbedInfoClient, EmbedInfoDTO, ReportClient, ReportDTO } from '../volunteer-tracking-client';

const client: EmbedInfoClient = new EmbedInfoClient();

export const EmbedInfoService = {
    getEmbedInfo: async (dto:EmbedInfoDTO):Promise<any> => {
        return await client.getEmbedInfo(dto)

    }
}